<template>
	<div id="home">


		<div class="banner">
			<img :src="imgList[num].imgUrl" alt="">
		</div>



		<ul class="tab-box">
			<li class="tab-list" v-for="(item,index) in tabs" :class="{active:index == num}" :key="index" @click="tab(index)">{{item}}</li>
		</ul>




	<div v-show="num==0">

	
		<!-- 翡翠行业四大痛点 -->
		<div class="column-wrap">
			<div class="column-title">
				<div class="column-t1">
					产品介绍
				</div>
				<div class="column-t2">
					什么是物联云平台？
				</div>
			</div>
			<div class="column-box clearfix">
				<div class="introduce-box">
						
					物联云是一个以小程序搭建的物联网云平台，
					用户只需登录小程序即可在线监控货物流转，及办理多种线上业务，
					整合了从进货、出入库、销售、物流、安全监控等各业务环节。
				</div>
			</div>	
		</div>	




		<div class="column-wrap">
			<div class="column-title">
				<div class="column-t1">
					产品优势
				</div>
				<div class="column-t2">
					竞品对比，优势尽显
				</div>
			</div>
			<div class="column-box clearfix">
				<div class="contrast-box">
					<div class="contrast-left wow bounceInLeft top__element">
						<div class="contrast-title">
							传统ERP应用
						</div>
						<div class="contrast-content">
							<div class="c-c-content">
								<div>
									适用性低只做库存管理
								</div>
								<div>
									蹲守办公点
								</div>
								<div>
									盘点费时费力
								</div>
								<div>
									人工监控防盗性差
								</div>
							</div>	
						</div>
					</div>
					<div class="contrast-right wow bounceInRight top__element">
						<div class="contrast-title">
							物联云平台
						</div>
						<div class="contrast-content">
							<div class="c-c-title">
								适用性高适用各种渠道
							</div>
							<div class="c-c-img">
								<img src="../assets/index/1.png" alt="">
							</div>
							<div class="c-c-title">
								移动办公
							</div>
							<div class="c-c-img">
								<img src="../assets/index/1.png" alt="">
							</div>
							<div class="c-c-title">
								自动盘点秒出报表
							</div>
							<div class="c-c-img">
								<img src="../assets/index/1.png" alt="">
							</div>
							<div class="c-c-title">
								实时监控 防盗性强
							</div>
						</div>
					</div>
					<div class="contrast-center">
						<img src="../assets/index/vs.png" alt="">
					</div>
				</div>
			</div>	
		</div>
		<!-- 产品业务 -->
		<div class="column-wrap">
			<div class="column-title">
				<div class="column-t1">
					产品业务
				</div>
				<div class="column-t2">
					从商品入库、销售、到出库运输， 监管覆盖整个业务圈？
				</div>
			</div>
			<div class="business-wrap">
				<div class="business-wdotted">
					<div class="business-dotted ">
						<div class="business-core">
							<div class="business-core-text">
								<div class="business-core-text1">
									物联云店
								</div>
								<div class="business-core-text2">
									(监控货物流转)
								</div>
							</div>
						</div>
					</div>
					<div class="business-content b1">
						<div class="business-c-text">
							<div class="business-c-text1">
								供应商
							</div>
							<div class="business-c-text1">
								(拿货入库)
							</div>
						</div>
					</div>
					<div class="business-content b2">
						<div class="business-c-text">
							<div class="business-c-text1">
								货主签收
							</div>
							<div class="business-c-text1">
								(身份校验)
							</div>
						</div>
					</div>
					<div class="business-content b3">
						<div class="business-c-text">
							<div class="business-c-text1">
								智能保物箱
							</div>
							<div class="business-c-text1">
								(轨迹追踪)
							</div>
						</div>
					</div>
					<div class="business-content b4">
						<div class="business-c-text">
							<div class="business-c-text1">
								销售出库
							</div>
							<div class="business-c-text1">
								(直播平台)
							</div>
						</div>
					</div>
					<div class="business-content b5">
						<div class="business-c-text">
							<div class="business-c-text1">
								主播
							</div>
							<div class="business-c-text1">
								(自助拿货)
							</div>
						</div>
					</div>
					
					<div class="business-content b6">
						<div class="business-c-text">
							<div class="business-c-text1">
								艺品溯源
							</div>
							<div class="business-c-text1">
								(绑定RFID)
							</div>
						</div>
					</div>
					<div class="business-tips t1">
						<image src="../../static/product/pro2.png" mode="widthFix"></image>
					</div>
					<div class="business-tips t2">
						<image src="../../static/product/pro2.png" mode="widthFix"></image>
					</div>
				</div>
			</div>
		</div>




		<div class="column-wrap">
			<div class="column-title">
				<div class="column-t1">
					产品报价
				</div>
				<div class="column-t2">
					多款套餐供您选择
				</div>
			</div>
			<div class="insured-wrap">
				<div class="insured-list">
					<div class="i1 insured-row">
						<div class="insured-text">
							套餐
						</div>
					</div>
					<div class="i2 insured-row">
						<div class="insured-text">
							价格
						</div>
					</div>
					<div class="i3 insured-row">
						<div class="insured-text">
							套餐内容
						</div>
					</div>
				</div>
				<div class="insured-list">
					<div class="i1 insured-row">
						<div class="insured-text">
							套餐一
						</div>
					</div>
					<div class="i2 insured-row">
						<div class="insured-text">
							<text>3.5</text>万/年
						</div>
					</div>
					<div class="i3 insured-row">
						<div class="insured-text">
							无源实时防盗 4节1.5米柜；
							硬件；标配300标签；
						</div>
					</div>
				</div>
				<div class="insured-list">
					<div class="i1  insured-row">
						<div class="insured-text">
							套餐二
						</div>
					</div>
					<div class="i2 insured-row ">
						<div class="insured-text">
							<text>1.8</text>万/年
						</div>
					</div>
					<div class="i3 insured-row ">
						<div class="insured-text">
							无源自动盘点 20平米;
							硬件;标配300标签
						</div>
					</div>
				</div>
				<div class="insured-list">
					<div class="i1  insured-row">
						<div class="insured-text">
							套餐三
						</div>
					</div>
					<div class="i2 insured-row ">
						<div class="insured-text">
							<text>1.4</text>万/年
						</div>
					</div>
					<div class="i3 insured-row ">
						<div class="insured-text">
							无源资产管理;
							硬件；标配500标签
						</div>
					</div>
				</div>
				<div class="insured-list">
					<div class="i1  insured-row">
						<div class="insured-text">
							套餐四
						</div>
					</div>
					<div class="i2 insured-row ">
						<div class="insured-text">
							<text>0.6</text>万/年
						</div>
					</div>
					<div class="i3 insured-row ">
						<div class="insured-text">
							有源实时防盗 100/个/年，
							硬件；标配300标签
						</div>
					</div>
				</div>
			</div>
		</div>	
	</div>




	<div class="column-2 column" v-show="num==1">
		<div class="product-img">
			<image src="../../static/images/bg.jpg" mode="widthFix"></image>
		</div>
		<div class="column-wrap">
			<div class="column-title">
				<div class="column-t1">
					产品简介
				</div>
				<div class="column-t2">
					什么是艺品溯源？
				</div>
			</div>
			<div class="column-box">
				<div class="introduce-box">
					艺品溯源是通过区块链系统连接产业链上各个参与方，对艺术品全程登记和共享，给要流通的艺术品分配可溯源的Token，充当艺术品的“销售许可证”。
					从本质上证明“此物是此物”，为持有者在提供技术
					性举证。
				</div>
			</div>
		</div>	
		
		<div class="column-wrap">
			<div class="column-title">
				<div class="column-t1">
					产品优势
				</div>
				<div class="column-t2">
					竞品对比，优势尽显
				</div>
			</div>
			<div class="column-box">
				<div class="contrast-box">
					<div class="contrast-left wow bounceInLeft top__element">
						<div class="contrast-title">
							普通溯源软件
						</div>
						<div class="contrast-content">
							<div class="c-c-content">
								<div>
									数据准确性低
								</div>
								<div>
									特征提取单一
								</div>
								<div>
									信息数据查询慢
								</div>
							</div>	
						</div>
					</div>
					<div class="contrast-right wow bounceInRight top__element">
						<div class="contrast-title">
							艺品溯源
						</div>
						<div class="contrast-content">
							<div class="c-c-title">
								多重溯源准确性高
							</div>
							<div class="c-c-img">
								<img src="../assets/index/1.png" alt="">
							</div>
							<div class="c-c-title">
								多维度特征提取
							</div>
							<div class="c-c-img">
								<img src="../assets/index/1.png" alt="">
							</div>
							<div class="c-c-title">
								区块链大数据溯源
							</div>
							
						</div>
					</div>
					<div class="contrast-center">
						<img src="../assets/index/vs.png" alt="">
					</div>
				</div>
			</div>
		</div>	
		<!-- 产品业务 -->
		<div class="column-wrap">
			<div class="column-title">
				<div class="column-t1">
					产品业务
				</div>
				<div class="column-t2">
					区块链系统连接产业链上各个参与方
				</div>
			</div>
			<div class="column-box">
				<div class="business-wrap">
					<div class="business-wdotted">
						<div class="business-dotted ">
							<div class="business-core">
								<div class="business-core-text">
									<div class="business-core-text1">
										艺品溯源
									</div>
									<div class="business-core-text2">
										(多维溯源)
									</div>
								</div>
							</div>
						</div>
						<div class="business-content s1">
							<div class="business-c-text">
								<div class="business-c-text1">
									区块链
								</div>
								<div class="business-c-text1">
									(大数据)
								</div>
							</div>
						</div>
						<div class="business-content s2">
							<div class="business-c-text">
								<div class="business-c-text1">
									源头追溯
								</div>
								<div class="business-c-text1">
									(多维记录)
								</div>
							</div>
						</div>
						<div class="business-content s3">
							<div class="business-c-text">
								<div class="business-c-text1">
									准确性高
								</div>
								<div class="business-c-text1">
									(一物一码)
								</div>
							</div>
						</div>
						<div class="business-content s4">
							<div class="business-c-text">
								<div class="business-c-text1">
									特征提取
								</div>
								<div class="business-c-text1">
									(显微摄像)
								</div>
							</div>
						</div>
						<div class="business-content s5">
							<div class="business-c-text">
								<div class="business-c-text1">
									多重参数
								</div>
								<div class="business-c-text1">
									(记录特征)
								</div>
							</div>
						</div>
						<div class="business-tips t1">
							<image src="../../static/product/pro2.png" mode="widthFix"></image>
						</div>
						<div class="business-tips t2">
							<image src="../../static/product/pro2.png" mode="widthFix"></image>
						</div>
					</div>
				</div>
			</div>	
		</div>	
	</div>









	<div class="column-3 column" v-show="num==2">
		<div class="column-wrap">
			<div class="column-title">
				<div class="column-t1">
					产品简介
				</div>
				<div class="column-t2">
					什么是智能保物箱？
				</div>
			</div>

			<div class="column-box">
				<div class="introduce-box">
					智能保物箱专为贵重资产运输途中，进行实时定位与监管，内置物联网定位模块，配合自动报警机制，保障您的物品安全，智能定位掌握物品动向，实现实时追踪定位、远程监控、远程操作，可定人、定时、定设备和定路线。
				</div>
			</div>
		</div>	
		
		<div class="column-wrap">
			<div class="column-title">
				<div class="column-t1">
					产品优势
				</div>
				<div class="column-t2">
					竞品对比，优势尽显
				</div>
			</div>
			<div class="column-box">
				<div class="contrast-box">
					<div class="contrast-left wow bounceInLeft top__element">
						<div class="contrast-title">
							同类竞品
						</div>
						<div class="contrast-content">
							<div class="c-c-content">
								<div>
									1.溯源产品
								</div>
								<div>
									2.物联监管平台
								</div>
								<div>
									3.智能保险箱
								</div>
							</div>	
						</div>
					</div>
					<div class="contrast-right wow bounceInRight top__element">
						<div class="contrast-title">
							物联云平台
						</div>
						<div class="contrast-content">
							<div class="c-c-title">
								平台优势尽显
							</div>
							<div class="c-c-img">
								<img src="../assets/index/1.png" alt="">
							</div>
							<div class="c-c-content">
								<div class="c-list">
									整合
									<span class="c-c-text">
										溯源产品、
									</span>
								</div>
								<div class="c-c-text c-list">
									物联监管、智能保险箱
								</div>
								<div class="c-list">
									等一体化物联服务
								</div>
							</div>
						</div>
					</div>
					<div class="contrast-center">
						<img src="../assets/index/vs.png" alt="">
					</div>
				</div>
			</div>
		</div>	
		<!-- 产品业务 -->
		<div class="column-wrap">
			<div class="column-title">
				<div class="column-t1">
					产品业务
				</div>
				<div class="column-t2">
					区块链系统连接产业链上各个参与方
				</div>
			</div>
			<div class="business-wrap">
				<div class="business-wdotted">
					<div class="business-dotted ">
						<div class="business-core">
							<div class="business-core-text">
								<div class="business-core-text1">
									保物箱
								</div>
								<div class="business-core-text2">
									(实时监控)
								</div>
							</div>
						</div>
					</div>
					<div class="business-content s1">
						<div class="business-c-text">
							<div class="business-c-text1">
								区块链
							</div>
							<div class="business-c-text1">
								(大数据)
							</div>
						</div>
					</div>
					<div class="business-content s2">
						<div class="business-c-text">
							<div class="business-c-text1">
								轨迹追踪
							</div>
							<div class="business-c-text1">
								(路线规划)
							</div>
						</div>
					</div>
					<div class="business-content s3">
						<div class="business-c-text">
							<div class="business-c-text1">
								实时监控
							</div>
							<div class="business-c-text1">
								(秒级报警)
							</div>
						</div>
					</div>
					<div class="business-content s4">
						<div class="business-c-text">
							<div class="business-c-text1">
								军工级箱体
							</div>
							<div class="business-c-text1">
								(车压不坏)
							</div>
						</div>
					</div>
					<div class="business-content s5">
						<div class="business-c-text">
							<div class="business-c-text1">
								人脸识别
							</div>
							<div class="business-c-text1">
								(远程开锁)
							</div>
						</div>
					</div>
					<div class="business-tips t1">
						<image src="../../static/product/pro2.png" mode="widthFix"></image>
					</div>
					<div class="business-tips t2">
						<image src="../../static/product/pro2.png" mode="widthFix"></image>
					</div>
				</div>
			</div>
		</div>	
	</div>








		
<div data-aos="fade-up" data-aos-offset="200">14561456</div>

		



	</div>
</template>
<script>
import banner from './banner.vue';
export default{
	name: 'App',
	data(){
		return{
			swiperOption:{
				loop: true, // 设置图片循环
				autoplay: true, //设置可自动播放
				speed: 1000, //自动播放的速度，每隔1秒滑动一次
				pagination: {
					el: ".swiper-pagination",//分页器的类名
					clickable: true //设置分页小圆点可手动点击
				} 
			},
			num: 0, 
			tabs: ["物联云平台", "艺品溯源","智能保险箱"],
			imgList: [
				{
					imgUrl: require('@/assets/probanner1.png')
				},
				{
					imgUrl: require('@/assets/probanner2.png')
				},
				{
					imgUrl: require('@/assets/probanner3.png')
				}
			],
			bannerUrl: ''


		}
	},
	components:{
		'v-banner': banner
	},
	methods:{

		// 
		// 你也可以在这里设置全局配置
		// AOS.init({
		// 	offset: 200,   
		// 	duration: 600,   //持续时间
		// 	easing: 'ease-in-sine',   
		// 	delay: 100
		// })
		tab(index) {
			this.num = index;
			// this.bannerUrl = this.imgList[index].imgUrl;
		}

	},
}
</script>
<style scoped>
	@import url("../resource/css/customProduct.css");
  .animate{
    transition: all 2s ease-in-out;
  }
</style>



// WEBPACK FOOTER //
// src/components/customProduct.vue